import React from 'react';
import { URLListItem, UrlItem } from './url-list-item';

interface URLListProps {
  urls: UrlItem[];
  selectedUrl: string | null;
  onSelectUrl: (id: string) => void;
  onDownloadMarkdown: (id: string) => void;
  onRemoveUrl: (id: string) => void;
  onFetchUrl: (id: string) => void;
}

export const URLList: React.FC<URLListProps> = ({
  urls,
  selectedUrl,
  onSelectUrl,
  onDownloadMarkdown,
  onRemoveUrl,
  onFetchUrl
}) => {
  return (
    <div className="h-[calc(100vh-20rem)] md:h-[calc(100vh-21rem)] lg:h-[calc(100vh-23rem)] overflow-y-auto scrollbar-thin">
      {urls.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-full text-muted-foreground">
          <p className="text-center text-sm mb-2">请添加 URL 开始使用</p>
          <p className="text-xs text-center text-muted-foreground/70">（最多支持 10 个 URL）</p>
        </div>
      ) : (
        <div className="space-y-3 pb-2">
          {urls.map(item => (
            <URLListItem
              key={item.id}
              item={item}
              isSelected={selectedUrl === item.id}
              onSelect={onSelectUrl}
              onDownload={onDownloadMarkdown}
              onRemove={onRemoveUrl}
              onFetch={onFetchUrl}
            />
          ))}
        </div>
      )}
    </div>
  );
}; 